import { ConfirmationIconButton, IconButton, Paper, Stack, Typography } from 'ui';
import { Close, Delete, DriveFileMove } from 'ui/icons';

type Props = {
  handleClose: () => void;
  handleDelete?: () => void;
  handleMove?: () => void;
  selected: number;
  actionPending?: boolean;
};

export const ActionBar = ({ selected, handleClose, handleDelete, handleMove, actionPending }: Props) => (
  <Paper elevation={2} sx={{ borderRadius: 4 }}>
    <Stack direction="row" gap={1} py={1} px={2} alignItems="center" justifyContent="space-between">
      <IconButton size="small" disabled={actionPending} onClick={handleClose}>
        <Close />
      </IconButton>
      <Typography>{`${selected} selected`}</Typography>

      <Stack direction="row" gap={1}>
        {handleDelete ? (
          <ConfirmationIconButton
            size="small"
            disabled={!selected || actionPending}
            onConfirm={handleDelete}
            message="Are you sure you want to delete the selected evidence?"
            title="Delete Evidence"
            data-testid="delete-evidence-button"
          >
            <Delete />
          </ConfirmationIconButton>
        ) : null}
        {handleMove ? (
          <IconButton size="small" disabled={!selected || actionPending} onClick={handleMove}>
            <DriveFileMove />
          </IconButton>
        ) : null}
      </Stack>
    </Stack>
  </Paper>
);
